// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__25Ce9","header":"ReportDetails_header__3OwiM","title":"ReportDetails_title__30KKu","left":"ReportDetails_left__2w2lK"};